<ng-container *ngIf="control">
  <div *ngIf="!control.valid && control.touched" class="invalid-feedback" data-cy="requiredField" style="display: block">{{ errors }}</div>
</ng-container>
